import axios from 'axios';

export default {
  getGoalsAbtesting({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/goalsAbtesting/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertGoalsAbtesting', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addGoalAbtesting({ commit, state }, { goal, event }) {
    return new Promise((resolve, reject) => {
      commit('addGoalAbtestingRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/goalsAbtesting/add`,
        params: goal,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addGoalAbtestingRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addGoalAbtestingRequestError', err);
          reject(err);
        });
    });
  },
  editGoalAbtesting({ commit, state }, { goal, event }) {
    return new Promise((resolve, reject) => {
      commit('editGoalAbtestingRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/goalsAbtesting/edit`,
        params: goal,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editGoalAbtestingRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editGoalAbtestingRequestError', err);
          reject(err);
        });
    });
  },
  deleteGoalAbtesting({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      commit('deleteGoalAbtestingRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/goalsAbtesting/destroy`,
        params: { id },
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteGoalAbtestingRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteGoalAbtestingRequestError', err);
          reject(err);
        });
    });
  }
};
